/** @jsxImportSource @emotion/react */
import {
  BlueLine,
  Button,
  Container,
  Divider,
  HeadingH2,
  Section,
  Text,
} from 'components/landing/ui';

import mic from '../../images/mic.svg';
import robot from '../../images/robot.svg';
import telegram from '../../images/telegram.svg';

const S6 = ({ inDevelopment }) => (
  <Container>
    <Section
      css={{
        paddingTop: 50,
        '@media (min-width:992px)': { paddingTop: 100 },
        '@media (min-width:1366px)': { paddingTop: 120 },
      }}
    >
      <div
        css={{
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
          marginBottom: 30,
          '@media (min-width:992px)': { marginBottom: 50 },
        }}
      >
        <HeadingH2 css={{ marginBottom: 20 }}>Сложно? Это поможет разобраться во всём!</HeadingH2>
        <BlueLine height={5} width={125} />
      </div>

      <div
        css={{
          flexDirection: 'column',
          width: '100%',
          '>div': {
            flexBasis: '100%',
            padding: 30,
            flexDirection: 'column',
            'a, button': { width: '100%' },
          },
          a: { marginTop: 'auto' },
          '@media (min-width:992px)': {
            flexDirection: 'row',
            '>div': { flexBasis: '34%', flexShrink: 1 },
          },
        }}
      >
        <div css={{ background: '#4B4B4B' }}>
          <div css={{ alignItems: 'center', marginBottom: 15, minHeight: 72 }}>
            <img src={mic} css={{ marginRight: 25, width: 50 }} />
            <HeadingH2 css={{ color: '#fff' }}>Обучающие вебинары</HeadingH2>
          </div>
          <BlueLine height={5} width={125} css={{ background: '#fff', marginBottom: 30 }} />

          <Text css={{ color: '#fff', marginBottom: 30 }}>
            Каждую среду в 19:00 мы проводим живой обучающий вебинар
          </Text>
          <a onClick={inDevelopment}>
            <Button type="transparent">Зарегистрироваться</Button>
          </a>
        </div>

        <div>
          <div css={{ alignItems: 'center', marginBottom: 15, minHeight: 72 }}>
            <img src={robot} css={{ marginRight: 25, width: 50 }} />
            <HeadingH2>ВК-БОТ учитель</HeadingH2>
          </div>
          <BlueLine height={5} width={125} css={{ background: '#4B4B4B', marginBottom: 30 }} />

          <Text css={{ marginBottom: 30 }}>
            Научиться пользоваться самостоятельно по урокам от чат-бота
          </Text>
          <a onClick={inDevelopment}>
            <Button type="gray">Запустить</Button>
          </a>
        </div>

        <div css={{ background: '#4B4B4B' }}>
          <div css={{ alignItems: 'center', marginBottom: 15, minHeight: 72 }}>
            <img src={telegram} css={{ marginRight: 25, width: 50 }} />
            <HeadingH2 css={{ color: '#fff' }}>Телеграм канал</HeadingH2>
          </div>
          <BlueLine height={5} width={125} css={{ background: '#fff', marginBottom: 30 }} />

          <Text css={{ color: '#fff', marginBottom: 30 }}>
            Будь в курсе последних новостей на нашем телеграм канале
          </Text>
          <a onClick={inDevelopment}>
            <Button type="transparent">Запустить</Button>
          </a>
        </div>
      </div>

      <Divider
        css={{
          marginTop: 50,
          '@media (min-width:992px)': { marginTop: 100 },
          '@media (min-width:1366px)': { marginTop: 120 },
        }}
      />
    </Section>
  </Container>
);

export default S6;
